import { InputNumber, InputNumberProps } from "antd";
import React from "react";

interface NumberInputProps extends InputNumberProps {
  prefix?: string;
  suffix?: string;
  className?: string;
  loading?: boolean;
}

export const NumberInput: React.FC<NumberInputProps> = ({
  prefix,
  suffix,
  className = "",
  loading = false,
  ...props
}) => {
  return (
    <InputNumber
      type="number"
      addonBefore={prefix}
      addonAfter={suffix}
      className={className}
      disabled={loading}
      {...props}
    />
  );
};
